export default __webpack_public_path__ + "static/SectionTwo_02_04-28cb44d7430c68234c108891285743a9.png";